import React, { FC, ReactElement } from 'react';
import { Trans } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import Button from 'common/components/Button/Button';
import { LoginStyles } from 'views/Pages/Authentication/Authentication.styles';

type ErrorPageProps = {
  status: string,
}

type ErrorStatus = {
  title: string,
  text: any,
  btnText?: string,
  btnLink?: string,
}

type ErrorCodes = {
  UserIsSuspended: ErrorStatus,
  UserIsBanned: ErrorStatus,
  UserIsDeactivated: ErrorStatus,
}

const useStyles = createUseStyles(LoginStyles);

const ErrorPage: FC<ErrorPageProps> = ({ status }): ReactElement => {
  const classes = useStyles();

  const errorDetails: ErrorCodes = {
    UserIsSuspended: {
      title: 'Account suspended.',
      text: 'Your account has been suspended. Please refer to our FAQs for further steps.',
      btnText: 'Read FAQ',
      btnLink: 'https://support.bake.io/en/articles/8286219-my-account-got-suspended-deactivated-how-to-unsuspend-reactivate-it',
    },
    UserIsBanned: {
      title: 'Account banned.',
      text: <p><Trans>Your account has been banned for violating our Terms and Conditions.</Trans></p>,
    },
    UserIsDeactivated: {
      title: 'Account deactivated.',
      text: 'Your account has been deactivated. Please refer to our FAQs for further steps.',
      btnText: 'Read FAQ',
      btnLink: 'https://support.bake.io/en/articles/8286219-my-account-got-suspended-deactivated-how-to-unsuspend-reactivate-it',
    },
  };

  return (
    <article className={`${classes.container}`}>
      <h1 className={classes.errorTitle}>
        <Trans>{errorDetails[status].title}</Trans>
      </h1>
      <p className="align-center">{errorDetails[status].text}</p>
      <div className="margin-top-24 margin-bottom-40 flex-horizontal-center">
        {errorDetails[status]?.btnText
          && <a
              target="_blank"
              rel="noopener noreferrer"
              href={errorDetails[status].btnLink}
              >
              <Button btnLink tabIndex={6}>
                <Trans>{errorDetails[status]?.btnText}</Trans>
              </Button>
            </a>
        }
        <a href="/login" className="ml-4">
          <Button primary tabIndex={6}>
            <Trans>Go Back</Trans>
          </Button>
        </a>
      </div>
    </article>
  );
};

export default ErrorPage;
